export default {
	Slide: 'διαφάνεια',
	Puzzle: 'Παζλ',
	'The puzzle is open!': 'Το παζλ είναι ανοιχτό!',
	'Congratulations!': 'Συγχαρητήρια!',
	'You get it': 'παίρνεις',
	'You get the task done': 'Έκανες την εργασία σου',

	'Show all blocked': 'Εμφάνιση όλων των αποκλεισμένων',

	Author: 'Συγγραφέας',
	'Reset filters': 'Επαναφορά φίλτρων',

	Blocked: 'Αποκλεισμένο',
	Unlocked: 'Ξεκλείδωτο',

	Change: 'Αλλαγή',

	'The student is blocked': 'Ο μαθητής έχει μπλοκαριστεί',
	'The student is blocked with a new price':
		'Ο μαθητής έχει αποκλειστεί με νέα τιμή',
	'To unlock this student, go to the "Restore" section':
		'Για να ξεκλειδώσετε αυτόν τον μαθητή, μεταβείτε στην ενότητα «Επαναφορά»',

	'Before blocking, you can change the price for the student':
		'Πριν από τον αποκλεισμό, μπορείτε να αλλάξετε την τιμή για τον μαθητή',

	'Block student': 'Μπλοκάρισμα μαθητή',

	'First month cost': 'Κόστος του πρώτου μήνα',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'ΠΡΟΕΙΔΟΠΟΙΗΣΗ! Μετά την εκ νέου αποθήκευση της εργασίας, οι μαθητές που ολοκλήρωσαν αυτήν την εργασία θα έχουν κλειστό το παζλ και θα πρέπει να το επαναλάβουν',

	"You cannot do homework in the student's platform":
		'Δεν μπορείτε να κάνετε εργασίες για το σπίτι στην πλατφόρμα του μαθητή',

	'Restore the student ?': 'Επαναφορά του μαθητή;',
	'Restore the teacher ?': 'Επαναφορά του δάσκαλου;',
	'Restore the franchise ?': 'Επαναφορά του φρανσάιζ;',

	'Transition to 50': 'Μετάβαση στα 50',
	'Transition to 100': 'Μετάβαση στο 100',

	fifty: 'πενήντα',
	hundred: 'εκατό',

	Faces: 'Πρόσωπα',

	Heroes: 'Ήρωες',
	Clothes: 'Τα ρούχα',
	Backgrounds: 'Τα φόντα',
	Souvenirs: 'Τα αναμνηστικά',

	'Coming soon': 'Σύντομα διαθέσιμο',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Ουάου! Συγχαρητήρια, αγοράσατε με επιτυχία αυτό το προϊόν.',
	'You can view all your purchases in the "Purchased" section':
		'Μπορείτε να δείτε όλες τις αγορές σας στην ενότητα «Αγορασμένα»',

	'Your savings': 'Οι αποταμιεύσεις σας',
	'You can spend them on something interesting!':
		'Μπορείτε να τα ξοδέψετε σε κάτι ενδιαφέρον!',

	'A student with this email address already exists':
		'Υπάρχει ήδη ένας μαθητής με αυτήν τη διεύθυνση ηλεκτρονικού ταχυδρομείου',

	'User with such email already exists':
		'Υπάρχει ήδη χρήστης με τέτοια διεύθυνση ηλεκτρονικού ταχυδρομείου',
	'Year of birth': 'Έτος γέννησης',
	Registration: 'Εγγραφή',
	'Surname of parents': 'Επώνυμο γονέων',
	School: 'Το σχολείο',
	'Field is required': 'Απαιτείται πεδίο',
	'Select age': 'Επιλογή ηλικίας',
	'No such teacher for this year': 'Δεν υπάρχει τέτοιος δάσκαλος για φέτος',
	'User with such phone number already exists':
		'Υπάρχει ήδη χρήστης με αυτόν τον αριθμό τηλεφώνου',
	'You are successfully registered': 'Εγγραφήκατε με επιτυχία',
	'Max length 20 chars': 'Μέγιστο μήκος 20 χαρακτήρες',
	'Після реєстрації вам надійде лист з логіном і паролем':
		'Μετά την εγγραφή, θα λάβετε ένα email με τα στοιχεία σύνδεσης και τον κωδικό πρόσβασής σας.',

	'INTERNATIONAL SCHOOL': 'ΔΙΕΘΝΕΣ ΣΧΟΛΕΙΟ',
	'Mental Arithmetic': 'Νοητική Αριθμητική',
	'For children aged 5-14.': 'Για παιδιά ηλικίας 5–14 ετών.',
	'Sign up for a trial lesson': 'Εγγραφείτε για ένα δοκιμαστικό μάθημα',
	'Parents name': 'Όνομα γονέα',
	'Childs age': 'Ηλικία παιδιού',
	Country: 'Χώρα',
	'Sign up': 'Εγγραφή',

	'Open offer agreement': 'Συμφωνία ανοιχτής προσφοράς',
	'Participate in online Indigo Olympiad':
		'Συμμετοχή στην διαδικτυακή Ολυμπιάδα Indigo!',
	Participate: 'Συμμετοχή',
	export: 'Εξαγωγή',

	wrong: 'Λάθος',
	right: 'Σωστό',
	match: {
		addition: 'πρόσθεση',
		multiply: 'πολλαπλασιασμός',
		divide: 'διαίρεση',
		abacus_random: 'τυχαίος άβακας',
		anzan: 'ανζάν',
		negative: 'αρνητικός αριθμός',
		column: 'στήλες',
	},

	timeIsOver: 'Ο χρόνος έχει τελειώσει',
	timer: 'Χρονομετρητής',
	'Back to Lessons': 'Πίσω στα μαθήματα',
	'Create Lesson': 'Δημιουργία μαθήματος',
	Assign: 'Ανάθεση',
	Home: 'Αρχική',
	'To cabinet': 'Στην προσωπική σελίδα',
	'Create a homework': 'Δημιουργήστε μια εργασία για το σπίτι',
	January: 'Ιανουάριος',
	February: 'Φεβρουάριος',
	March: 'Μάρτιος',
	April: 'Απρίλιος',
	May: 'Μάιος',
	June: 'Ιούνιος',
	July: 'Ιούλιος',
	August: 'Αύγουστος',
	'Group nickname': 'Ψευδώνυμο ομάδας',
	September: 'Σεπτέμβριος',
	October: 'Οκτώβριος',
	November: 'Νοέμβριος',
	December: 'Δεκέμβριος',
	Overall: 'Ολικός',
	Active: 'Ενεργός',
	'Contract number': 'Αριθμός σύμβασης',
	'For parents': 'Για τους γονείς',
	'Choose lessons': 'Επιλέξτε μαθήματα',
	Save: 'Αποθήκευση',
	'Students active': 'Ενεργοί μαθητές',
	Close: 'Κλείσιμο',
	'Change birthday': 'Αλλαγή ημερομηνίας γέννησης',
	Sent: 'Απεστάλη',
	'Choose date': 'Επιλέξτε ημερομηνία',
	'Include students': 'Συμπεριλάβετε μαθητές',
	'Add service': 'Προσθήκη υπηρεσίας',
	'Create folder': 'Δημιουργία φακέλου',
	Answer: 'Απάντηση',
	Price: 'Τιμή',
	'Date of creating': 'Ημερομηνία δημιουργίας',
	Month: 'Μήνας',
	unpaid: 'Απλήρωτο',
	paid: 'Πληρωμένο',
	'Excluded students': 'Αποκλεισμένοι μαθητές',
	'Selected groups': 'Επιλεγμένες ομάδες',
	Monday: 'Δευτέρα',
	Tuesday: 'Τρίτη',
	Wensday: 'Τετάρτη',
	Thusday: 'Πέμπτη',
	Friday: 'Παρασκευή',
	Saturday: 'Σάββατο',
	Sunday: 'Κυριακή',
	Mo: 'Δε',
	Tu: 'Τρ',
	We: 'Τε',
	Th: 'Πε',
	Fr: 'Πα',
	Sa: 'Σα',
	Su: 'Κυ',
	End: 'Τέλος',
	'Add discount': 'Προσθήκη έκπτωσης',
	Edit: 'Επεξεργασία',
	'Parent found': 'Βρέθηκε ο γονέας',
	'Changes saved': 'Οι αλλαγές αποθηκεύτηκαν',
	'The passwords of the parent and the student should not coincide':
		'Οι κωδικοί πρόσβασης του γονέα και του μαθητή δεν πρέπει να συμπίπτουν',
	'Your region`s price is set to': 'Η τιμή της περιοχής σας έχει οριστεί σε',
	'and the holder`s reward is': 'και η ανταμοιβή του κατόχου είναι',
	'regardless of the set price': 'ανεξάρτητα από την καθορισμένη τιμή',
	'The given password is not unique for this email':
		'Ο κωδικός πρόσβασης που δίνεται δεν είναι μοναδικός για αυτό το email',
	'Enter a valid email address.':
		'Εισαγάγετε μια έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου',
	'The phone number entered is not valid':
		'Ο αριθμός τηλεφώνου που καταχωρήσατε δεν είναι έγκυρος',
	Holiday: 'Διακοπές',
	'Working days': 'Εργάσιμες ημέρες',
	Street: 'Ο δρόμος',
	'Location name': 'Όνομα τοποθεσίας',
	District: 'Περιοχή',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Η νοητική αριθμητική είναι μια τεχνική προφορικού υπολογισμού που αναπτύσσει γρήγορα την πνευματική ικανότητα και τη νοημοσύνη ενός παιδιού ηλικίας μεταξύ 5 και 14 ετών. Η διαδικασία εκπαίδευσης λαμβάνει χώρα σε ειδικό ιαπωνικό άβακα (Soroban). Η νοητική αριθμητική εκπαιδεύει ταυτόχρονα το αριστερό και το δεξί ημισφαίριο του εγκεφάλου, βελτιώνοντας την οπτική μνήμη, τη συγκέντρωση, τον δημιουργικό προσανατολισμό, τη φανταστική σκέψη των παιδιών και την τάση τους για γρήγορη ανάγνωση.',
	'Field required': 'Απαιτούμενο πεδίο',
	'Type of legal activity': 'Είδος νομικής δραστηριότητας',
	'Legal address': 'Νομική διεύθυνση',
	'Registration number': 'Αριθμός καταχώρισης',
	'Add Group': 'Προσθήκη ομάδας',
	'Add a student': 'Προσθήκη μαθητή',
	Add: 'Προσθήκη',
	'Add file': 'Προσθήκη αρχείου',
	Signin: 'Είσοδος',
	'Bonus days': 'Ημέρες μπόνους',
	'Bonus weeks': 'Εβδομάδες μπόνους',
	'Are you sure you want to delete?':
		'Είστε σίγουροι ότι θέλετε να διαγράψετε;',
	Delete: 'Διαγραφή',
	Days: 'Ημέρες',
	Confirm: 'Επιβεβαιώνω',
	Cancel: 'Ακύρωση',
	Week: 'Εβδομάδα',
	Weeks: 'Εβδομάδες',
	'Group age name': 'Όνομα ηλικιακής ομάδας',
	'Set bonus days': 'Ορισμός ημερών μπόνους',
	'Default language': 'Προεπιλεγμένη γλώσσα',
	'With english': 'Με τα αγγλικά',
	'Without english': 'Χωρίς τα αγγλικά',
	'Paid status': 'Κατάσταση επί πληρωμή',
	'Not paid': 'Δεν έγινε πληρωμή',
	Turnover: 'Τζίρος',
	Block: 'Αποκλεισμός',
	'On holidays': 'Σε διακοπές',
	Language: 'Γλώσσα',
	Discounts: 'Προσφορές',
	Message: 'Μήνυμα',
	Subject: 'Θέμα',
	Homework: 'Ασκήσεις για το σπίτι',
	'Homework ': 'Ασκήσεις',
	'Homework on': 'Εργασία για το σπίτι για',
	'You need to complete the exercises': 'Πρέπει να ολοκληρώσετε τις ασκήσεις',
	HomeworkList: 'Εργασία για το σπίτι', // чтобы не дублировать ключ
	'Invoice for': 'Λογαριασμός για πληρωμή',
	"PJSC CB 'PRIVATBANK' in Kyiv": "PJSC CB 'PRIVATBANK' στο Κίεβο",
	Account: 'Λογαριασμός',
	Supplier: 'Προμηθευτής',
	Buyer: 'Αγοραστής',
	'Bank code': 'Κωδικός τράπεζας',
	'Type phone number or email': 'Πληκτρολογήστε αριθμό τηλεφώνου ή email',
	'Type password': 'Πληκτρολογήστε τον κωδικό πρόσβασης',
	'Forgot password': 'Ξέχασα τον κωδικό πρόσβασης',
	'Type your email': 'Πληκτρολογήστε το email σας',
	Send: 'Αποστολή',
	'Email sent': 'Το μήνυμα ηλεκτρονικού ταχυδρομείου στάλθηκε',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Εάν υπάρχει εγγραφή με το συγκεκριμένο email, θα λάβετε email από εμάς με τις επόμενες οδηγίες για να αποκτήσετε ξανά πρόσβαση στον λογαριασμό σας.',
	'Back to the sign in': 'Επιστροφή στη σύνδεση',
	'Password or login is not correct':
		'Ο κωδικός πρόσβασης ή η σύνδεση δεν είναι σωστά',
	'Password recovery': 'Ανάκτηση κωδικού πρόσβασης',
	'Type your new password here':
		'Πληκτρολογήστε τον νέο σας κωδικό πρόσβασης εδώ',
	'Set new password': 'Ορισμός νέου κωδικού πρόσβασης',
	'Learn more': 'Μάθετε περισσότερα',
	'About Us': 'Σχετικά με εμάς',
	Company: 'Εταιρεία',
	Jobs: 'Εργασία',
	Press: 'Τύπος',
	'Terms of Use': 'Όροι Χρήσης',
	'Privacy Policy': 'Πολιτική Απορρήτου',
	'Need help?': 'Χρειάζεστε βοήθεια;',
	'Contact us': 'Επικοινωνήστε μαζί μας',
	'Become franchise': 'Γίνετε φρανσάιζ',
	'Select language': 'Επιλογή γλώσσας',
	English: 'Αγγλικά',
	Russian: 'Ρωσικά',
	Azerbaijani: 'Αζερμπαϊτζάν',
	Ukrainian: 'Ουκρανικά',
	Polish: 'Πολωνικά',
	Management: 'Διαχείριση',
	'Master Franchise': 'Κύριο φρανσάιζ',
	Franchise: 'Φρανσάιζ',
	Teachers: 'Οι δάσκαλοι',
	Groups: 'Ομάδες',
	Students: 'Οι μαθητές',
	Student: 'Ο μαθητής',
	Parents: 'Οι γονείς',
	Profile: 'Προφίλ',
	'My profile': 'Το προφίλ μου',
	Finance: 'Οικονομικά',
	Reports: 'Αναφορές',
	Report: 'Έκθεση',
	Upload: 'Μεταφόρτωση',
	List: 'Λίστα',
	Payments: 'Πληρωμές',
	Documents: 'Έγγραφα',
	Lessons: 'Μαθήματα',
	Materials: 'Υλικά',
	Shop: 'Κατάστημα',
	Statistics: 'Στατιστική',
	Settings: 'Ρυθμίσεις',
	Pages: 'Σελίδες',
	Logout: 'Έξοδος',
	Dashboard: 'Προσωπική σελίδα',
	'Access denied': 'Δεν επιτρέπεται η πρόσβαση',
	Create: 'Δημιουργία',
	New: 'Νέο',
	Download: 'Λήψη',
	Status: 'Κατάσταση',
	'Payment Date': 'Ημερομηνία πληρωμής',
	'Payment Amount': 'Ποσό πληρωμής',
	'Start time': 'Ώρα έναρξης',
	'Group age': 'Ηλικία της ομάδας',
	Junior: 'Μικρότεροι',
	Average: 'Μεσαίοι',
	Class: 'Τάξη',
	Older: 'Μεγαλύτεροι',
	Region: 'Περιοχή',
	Group: 'Ομάδα',
	Person: 'Πρόσωπο',
	Finances: 'Οικονομικά',
	Actions: 'Ενέργειες',
	'Send invoice': 'Αποστολή τιμολογίου',
	'Download invoice': 'Λήψη τιμολογίου',
	'Send email': 'Αποστολή email',
	'Create Student': 'Δημιουργία μαθητή',
	'The beginning of holidays': 'Η αρχή των διακοπών',
	'Start of study': 'Έναρξη μελέτης',
	'Group name': 'Όνομα ομάδας',
	'Group address': 'Διεύθυνση ομάδας',
	'Group teacher': 'Δάσκαλος ομάδας',
	'Group students': 'Μαθητές της ομάδας',
	'Group statistics': 'Στατιστικά ομάδας',
	Search: 'Έρευνα',
	'General information': 'Γενικές πληροφορίες',
	'Phone number': 'Αριθμός τηλεφώνου',
	'First name': 'Όνομα',
	Surname: 'Πατρώνυμο',
	'Last name': 'Επώνυμο',
	'Date of birth': 'Ημερομηνία γέννησης',
	Password: 'Κωδικός πρόσβασης',
	'Additional information': 'Πρόσθετες πληροφορίες',
	'Id code': 'Κωδικός αναγνώρισης',
	Passport: 'Διαβατήριο',
	'Without email newsletter':
		'Χωρίς ενημερωτικό δελτίο μέσω ηλεκτρονικού ταχυδρομείου',
	'With email newsletter':
		'Με ενημερωτικό δελτίο μέσω ηλεκτρονικού ταχυδρομείου',
	'Financial information': 'Οικονομικές πληροφορίες',
	Royalty: 'Ιδιοκτησία',
	'PR contribution': 'Συνεισφορά PR',
	Currency: 'Νόμισμα',
	Comment: 'Σχόλια',
	Paid: 'Έμμισθος',
	Invoices: 'Τιμολόγια',
	Bills: 'Γραμμάτια',
	Acts: 'Πράξεις',
	Scan: 'Σάρωση',
	Level: 'Επίπεδο',
	'Action with numbers': 'Πράξη με αριθμούς',
	'Action with number': 'Πράξη με αριθμό',
	'Number of expressions': 'Αριθμός εκφράσεων',
	'Number of expression': 'Αριθμός έκφρασης',
	'Imaginary abacus': 'Άβακας στη φαντασία',
	'Period report': 'Έκθεση περιόδου',
	City: 'Πόλη',
	'Full name franchise': 'Πλήρες όνομα φρανσάιζ',
	'Сost of education': 'Κόστος εκπαίδευσης',
	'Turnover franchise': 'Τζίρος φρανσάιζ',
	'Discount sum': 'Ποσό έκπτωσης',
	Proprietor: 'Ιδιοκτήτης',
	'Additional products and services': 'Επιπλέον προϊόντα και υπηρεσίες',
	'Full name student': 'Ονοματεπώνυμο φοιτητή',
	'Period of study': 'Περίοδος σπουδών',
	'Bonus-days': 'Μπόνους-ημέρες',
	'Amount of days': 'Αριθμός ημερών',
	'Total days': 'Σύνολο ημερών',
	'Language of instruction': 'Γλώσσα διδασκαλίας',
	Teacher: 'Δάσκαλος',
	Discount: 'Έκπτωση',
	Remuneration: 'Αμοιβή',
	Goods: 'Προϊόντα',
	'Date of creation': 'Ημερομηνία δημιουργίας',
	'Date of payment': 'Ημερομηνία πληρωμής',
	'Goods (works, services)': 'Αγαθά (έργα, υπηρεσίες)',
	Quantity: 'Ποσότητα',
	Units: 'Μονάδες',
	Amount: 'Ποσό',
	Sum: 'Τελικό ποσό',
	'Sum Sub': 'Υποσύνολο',
	Financial: 'Οικονομικό',
	Additional: 'Επιπλέον',
	General: 'Γενικό',
	Total: 'Σύνολο',
	'Training materials': 'Εκπαιδευτικό υλικό',
	'Learning contract': 'Σύμβαση μάθησης',
	Games: 'Παιχνίδια',
	'NUMBER OF 11 TO 120': 'Αριθμοί από 11 έως 120',
	Complexity: 'Βαθμός δυσκολίας',
	Start: 'Αρχή',
	'Speedy numbers': 'Γρήγοροι αριθμοί',
	Anzan: 'Ανζάν',
	'Abacus is random': 'Ο άβακας είναι τυχαίος',
	Multiplication: 'Πολλαπλασιασμός',
	Division: 'Διαίρεση',
	Abacus: 'Άβακας',

	'Multiplying by 20': 'Πολλαπλασιασμός έως 20',
	Squared: 'Στο τετράγωνο',
	'Division to 20': 'Διαίρεση έως 20',
	Speed: 'Ταχύτητα',
	Repeat: 'Επανάληψη',
	'Game type': 'Τύπος παιχνιδιού',
	'Digit type': 'Τύπος ψηφίου',
	Digit: 'Ψηφίο',
	Time: 'Χρόνος',
	Oral: 'Άβακας στη φαντασία',
	Second: 'Δευτερόλεπτα',
	'Calculation method': 'Μέθοδος υπολογισμού',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Μόνο αρνητικοί αριθμοί που ξεκινούν με 99, 999, 9999 κ.λπ., ανάλογα με την πολυπλοκότητα της παράστασης: -9, -2, -3, -1 ...',
	'Only subtraction': 'Μόνο αφαίρεση',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Μόνο θετικοί αριθμοί που ξεκινούν με 0. Παράδειγμα: +1, +4, +6, +9, +5 ...',
	'Only add': 'Μόνο πρόσθεση',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Οι αριθμοί πέφτουν τυχαία, ξεκινώντας από το 0. Παράδειγμα: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Τυχαίοι αριθμοί',
	'CHOOSE COMPLEXITY:': 'ΕΠΙΛΕΞΤΕ ΠΟΛΥΠΛΟΚΟΤΗΤΑ:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'ΠΟΣΟΤΗΤΑ ΕΝΕΡΓΕΙΩΝ ΜΕ ΑΡΙΘΜΟ',
	FAMILY: 'ΟΙΚΟΓΕΝΕΙΑ',
	'BIG FRIENDS': 'ΜΕΓΑΛΟΙ ΦΙΛΟΙ',
	'LITTLE FRIENDS': 'ΜΙΚΡΟΙ ΦΙΛΟΙ',
	'JUST FRIENDS': 'ΑΠΛΑ ΦΙΛΟΙ',
	'big friends': 'μεγάλοι φίλοι',
	'small friends': 'μικροί φίλοι',
	elementary: 'απλά φίλοι',
	family: 'οικογένεια',
	Sound: 'Ήχος',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Συγχαρητήρια! Τα κατάφερες! Τώρα μπορείς να προχωρήσεις στις ακόλουθες ασκήσεις:',
	'RIGHT. ANSWER:': 'ΣΩΣΤΑ. ΑΠΑΝΤΗΣΗ:',
	CORRECT: 'ΣΩΣΤΑ',
	'NOT CORRECT': 'ΔΕΝ ΕΙΝΑΙ ΣΩΣΤΟ',
	'Try again': 'Δοκίμασε ξανά',
	expression: 'Παράσταση',
	next: 'επόμενος',
	Next: 'Επόμενος',
	Previous: 'Προηγούμενο',
	Loading: 'Φόρτωση',
	back: 'πίσω',
	Back: 'Πίσω',
	ANSWER: 'ΑΠΑΝΤΗΣΗ',
	Lesson: 'Μάθημα',
	'History statistics': 'Στατιστικά ιστορικού',
	Open: 'Ανοιχτό',
	'Game statistics per day': 'Στατιστικά παιχνιδιού ανά ημέρα',
	'Total played games': 'Σύνολο παιγμένων παιχνιδιών',
	'Total correct answers': 'Σύνολο σωστών απαντήσεων',
	'Total played:': 'Σύνολο παιγμένων:',
	Feedback: 'Ανατροφοδότηση',
	'Leave a review': 'Αφήστε μια αξιολόγηση',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Αφήστε μας τα σχόλια ή τις επιθυμίες σας και σίγουρα θα τα λάβουμε υπόψη στην εργασία μας.',
	'Payment history': 'Ιστορικό πληρωμών',
	'Payment status': 'Κατάσταση πληρωμής',
	Pay: 'Πληρωμή',
	Payer: 'Πληρωτής',
	'Getting a discount': 'Λήψη έκπτωσης',
	Training: 'Εκπαίδευση',
	Tasks: 'Εργασίες',

	'Current task': 'Τρέχουσα εργασία',
	'Only task': 'Άσκηση',
	'Next tasks': 'Επόμενες εργασίες',
	'Online abacus': 'Ηλεκτρονικός άβακας',
	'Base 50/100': 'Βάση 50/100',
	multiply_base: 'πολλαπλασιασμός_βάσης',
	divided: 'διαιρεμένος',
	'Do not show this instruction again': 'Μην εμφανίσετε ξανά αυτήν την οδηγία',
	'Instructions for homework': 'Οδηγίες για την εργασία στο σπίτι',
	divider: 'διαιρέτης',
	'Multiplication table': 'Πίνακας πολλαπλασιασμού',
	Restore: 'Επαναφορά',
	Left: 'Έμεινε',
	'Restore Hierarchy': 'Επαναφορά ιεραρχίας',
	total: 'σύνολο',
	active: 'ενεργός',
	blocked: 'μπλοκαρισμένο',

	pageError: {
		403: 'Απαγορεύτηκε η πρόσβαση.',
		404: 'Αυτή η σελίδα δεν υπάρχει. Παρακαλώ προσπαθήστε ξανά.',
		500: 'Ο διακομιστής δεν αποκρίνεται. Δοκιμάστε ξανά.',
	},

	error: {
		'Account deactivated': 'Ο λογαριασμός απενεργοποιήθηκε',
	},

	modalNewVersion: {
		text:
			'Χρησιμοποιείτε μια παλιά έκδοση του ιστότοπου. Υπάρχει πλέον διαθέσιμη ενημέρωση.',
		btn: 'Ανανέωση',
	},

	games: {
		negativeNumbers: 'Αρνητικοί αριθμοί',
		pause: 'Παύση',
		resume: 'Συνέχιση',
		columns: {
			name: 'Στήλες',
			users: 'Αριθμός παικτών',
			user: 'Παίκτης',
			userNames: 'Ονόματα παικτών',
		},
	},

	'Indigo-dollars': 'Ίντιγκο δολάρια',
	Balance: 'Υπόλοιπο',

	modalIndigoDollars: {
		submit: 'Αποστολή',
		cancel: 'Ακύρωση',
		title: 'Ίντιγκο δολάρια',
		balance: 'Τρέχον υπόλοιπο',
		amount: 'Ποσό',
		reason: 'Σχόλιο',
	},

	modalAddNotification: {
		title: 'Προσθήκη ειδοποίησης',
		submit: 'Αποστολή',
		cancel: 'Ακύρωση',
		empty: 'Δεν υπάρχουν ειδοποιήσεις',
	},

	modalTransactionsHistory: {
		title: 'Ιστορικό συναλλαγών',
		type: {
			withdraw: 'Απόσυρση',
			deposit: 'Φόρτιση λογαριασμού',
		},
		empty: 'Η λίστα πληρωμών είναι κενή',
	},

	modalCopyHomework: {
		title: 'Αντιγραφή εργασιών',
		label:
			'Επιλέξτε την ημερομηνία στην οποία θέλετε να αντιγράψετε την εργασία σας',
		submit: 'Αντιγραφή',
		cancel: 'Ακύρωση',
	},

	reportsPage: {
		history: {
			title: 'Ιστορικό αλλαγών',
			empty: 'Η λίστα είναι κενή',
			table: {
				date: 'Ημερομηνία τροποποίησης',
				field_name: 'Ενέργεια',
				old_value: 'Παλιά τιμή',
				new_value: 'Νέα τιμή',
				user: 'Τροποποιήθηκε από τον χρήστη',
			},
		},
	},

	pageShop: {
		title: 'Κατάστημα',
		description:
			'Στο κατάστημα μπορείτε να αγοράσετε διάφορα προϊόντα για να βελτιώσετε την οπτική εμφάνιση του προσωπικού σας λογαριασμού.',
		tabs: {
			all: 'Όλα τα προϊόντα',
			purchased: 'Αγορασμένα',
		},
		item: {
			off_all: 'Όχι',
			status: {
				AVAILABLE: 'Συνιστάται',
				DEPRECATED: 'Δεν είναι διαθέσιμο',
				COMING_SOON: 'Σύντομα',
			},
			is_activated: 'Επιλεγμένο',
			set_active: 'Επιλογή',
			unset_active: 'Απενεργοποίηση',
			preview: 'Προεπισκόπηση',
			is_free: 'Δωρεάν',
			buy: 'Αγορά',
			bought: 'Αγοράστηκε',
			purchased: 'Αγορασμένο',
		},
		empty: {
			all: 'Δεν υπάρχουν διαθέσιμες αναβαθμίσεις',
			purchased: 'Δεν αγοράστηκαν αναβαθμίσεις',
		},
		toast: {
			error: 'Παρουσιάστηκε σφάλμα',
			notEnoughMoney: 'Μη επαρκές υπόλοιπο',
			itemBought: 'Η αναβάθμιση αποκτήθηκε',
			itemActivated: 'Η αναβάθμιση ενεργοποιήθηκε',
			itemDeactivated: 'Η αναβάθμιση απενεργοποιήθηκε',
		},
		confirmPurchase: {
			title: 'Επιβεβαίωση αγοράς',
			message: 'Είστε βέβαιοι ότι θέλετε να αγοράσετε αυτό το αντικείμενο;',
			confirm: 'Ναι, αγόρασε',
			cancel: 'Ακύρωση',
		},
	},

	demo: {
		title: 'Δωρεάν μάθημα επίδειξης',
		tutorial: {
			title: 'Οδηγίες',
			text:
				'Καλώς ορίσατε στο διαδικτυακό μάθημα επίδειξης της Indigo Mental για τη νοητική αριθμητική.\nΗ Indigo Mental είναι η καλύτερη σχολή νοητικής αριθμητικής στον κόσμο. Η εκτεταμένη εμπειρία της εταιρείας και η επιτυχία πολλών μαθητών παγκοσμίως σε Ολυμπιάδες αποδεικνύουν ότι αυτή η μέθοδος είναι μοναδική και πραγματικά αποτελεσματική. Πολλοί γονείς έχουν πειστεί εδώ και καιρό για αυτή τη μέθοδο και χαίρονται με τις επιτυχίες των παιδιών τους όχι μόνο στην αριθμητική, αλλά και σε άλλες επιστήμες, τη μουσική και τον αθλητισμό, και έχουν παρατηρήσει ένα σημαντικό άλμα στις πνευματικές ικανότητες του παιδιού τους.\nΗ νοητική αριθμητική είναι μια ιαπωνική μέθοδος ταχείας νοητικής αριθμητικής που αναπτύσσει γρήγορα τις νοητικές ικανότητες και τη νοημοσύνη ενός παιδιού. Η μαθησιακή διαδικασία γίνεται χρησιμοποιώντας έναν ειδικό ιαπωνικό άβακα (Soroban). Η νοητική αριθμητική εκπαιδεύει τόσο το αριστερό όσο και το δεξί ημισφαίριο του εγκεφάλου, βελτιώνοντας την οπτική μνήμη, τη συγκέντρωση, τη δημιουργικότητα και τη φανταστική σκέψη των παιδιών.\nΑς ξεκινήσουμε να μαθαίνουμε τη νοητική αριθμητική. Για να το κάνετε αυτό, κάντε κλικ στο κουμπί «PLAY» στο παρακάτω βίντεο, ακούστε και επαναλάβετε.',
		},
	},

	disableStudent: {
		btn: 'Απενεργοποίηση μαθητή',
		list: 'Μαθητές χωρίς ημερομηνία απενεργοποίησης',
		modal: {
			title: 'Απενεργοποίηση μαθητή',
			description: 'Πρόκειται να αποσυνδέσετε τον μαθητή.',
			fieldLabel: 'Επιλέξτε μήνα',
			btnSubmit: 'Απενεργοποίηση',
			btnCancel: 'Ακύρωση',
		},
	},
}
